import { type RecordingLiveSurfaceAdapter } from './types';

const createNoopRecordingLiveSurfaceAdapter = (): RecordingLiveSurfaceAdapter => ({
  start: async () => {},
  update: async () => {},
  end: async () => {},
  setOnAction: () => {},
  endStaleInstances: async () => {},
});

export const recordingLiveSurfaceAdapter = createNoopRecordingLiveSurfaceAdapter();
